var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGainsLosses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.999,
    height: 30,
    rx: 14.9995,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9995 0C6.71551 0 0 6.716 0 15C0 15.2009 0.00395012 15.4009 0.0117769 15.5999C0.326665 7.59397 6.91642 1.19979 14.9995 1.19979C23.0826 1.19979 29.6724 7.59397 29.9872 15.5999C29.9951 15.4009 29.999 15.2009 29.999 15C29.999 6.716 23.2835 0 14.9995 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.9999C23.2845 29.9999 30 23.2839 30 14.9999C30 14.799 29.9961 14.599 29.9882 14.4C29.6733 22.4059 23.0836 28.8001 15.0005 28.8001C6.91739 28.8001 0.327628 22.4059 0.0127539 14.4C0.00492612 14.599 0.000975984 14.799 0.000975966 14.9999C0.000975242 23.2839 6.71649 29.9999 15.0005 29.9999Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H21V8.27L17.29 5H8V22Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H20V7.27L16.29 4H7V21Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5914 8.53H8.69141V9.53H18.5914V8.53Z",
    fill: "#B4B4B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5914 11.53H8.69141V12.53H18.5914V11.53Z",
    fill: "#B4B4B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5914 14.53H8.69141V15.53H18.5914V14.53Z",
    fill: "#B4B4B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8414 17.53H8.69141V18.53H14.8414V17.53Z",
    fill: "#B4B4B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.5L25 7.05L17.59 17.92L15 19.5L15.62 16.4L23 5.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4109 18.21L16.0009 18.7L15.2109 19.2L15.4109 18.21Z",
    fill: "#FE5F5F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.61 9.09L25 7.05L24.52 6.67L16.89 17.9L16.94 17.94L15.54 18.72L15.8 17.06L15.86 17.11L23.48 5.88L23 5.5L15.61 16.39L15.62 16.4L15 19.5L17.59 17.92L17.61 17.93L23.61 9.09Z",
    fill: "#DD2712"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7694 17.66L24.3394 6.51999L23.6794 6.01999L16.1094 17.15L16.7694 17.66Z",
    fill: "#FE5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainsLosses);
export default __webpack_public_path__ + "static/media/gainsLosses.10d2298f5a83db299e18c080bc081fd0.svg";
export { ForwardRef as ReactComponent };